import React, { useEffect, useState } from 'react';

import ValidationAlert from '../../../app/components/ValidationAlert';
import { CreateUpdateProfileCategoryDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNavigation } from '../../../common/navigation';

import { ProfileCategoryEditorForm } from './ProfileCategoryEditorForm';
import { ProfileCategoryEditorFormYears } from './ProfileCategoryEditorFormYears';
import { ProfileCategoryEditorControls } from './ProfileCategoryEditorControls';

interface ProfileCategoryEditorProps {
  id?: string;
  profileCategory: CreateUpdateProfileCategoryDto;
  handleClose?: () => void;
  setNotSaved?: (notSaved: boolean) => void;
  notSaved?: boolean;
  readOnly?: boolean;
  closeAfterCompleted?: boolean;
  onCompleted: (
    profileCategory: CreateUpdateProfileCategoryDto,
    id?: string,
  ) => Promise<{
    saved: boolean;
    errors: string[];
  }>;
}

export const ProfileCategoryEditor: React.FC<
  ProfileCategoryEditorProps
> = props => {
  const [profileCategory, setProfileCategory] = useState(props.profileCategory);
  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [saveErrors, setSaveErrors] = useState<string[]>([]);
  const [companyIds, setCompanyIds] = useState<string[]>([]);

  const pok = usePokCore();
  const nav = useNavigation();
  const notifications = useNotifications();

  useEffect(() => {
    setSaveErrors([]);
    setShowSaveErrors(false);
    if (!props.notSaved) {
      setProfileCategory(props.profileCategory);
      pok.companies
        .getManyWithoutLogo()
        .then(data => {
          if (data && data.length > 0) {
            setCompanyIds(data.map(c => c.id));
          }
        })
        .catch(errorResponse => {
          notifications.caughtError(errorResponse);
        });
    }
  }, [pok.companies, props.profileCategory, notifications, props.notSaved]);

  const handleClose = () => {
    nav.profileCategories();
  };

  const propertyChange = (obj: Partial<CreateUpdateProfileCategoryDto>) => {
    setProfileCategory({ ...profileCategory, ...obj });
    props.setNotSaved?.(true);
  };

  return (
    <>
      <ProfileCategoryEditorForm
        profileCategory={profileCategory}
        companyIds={companyIds}
        propertyChange={propertyChange}
        readOnly={props.readOnly}
      />
      <ProfileCategoryEditorFormYears
        profileCategory={profileCategory}
        propertyChange={propertyChange}
        readOnly={props.readOnly}
      />
      <ValidationAlert
        show={showSaveErrors}
        errors={saveErrors}
        className="m-3"
      />
      <div className="d-flex justify-content-end pt-4">
        <ProfileCategoryEditorControls
          id={props.id}
          profileCategory={profileCategory}
          closeAfterCompleted={props.closeAfterCompleted}
          onCompleted={props.onCompleted}
          setSaveErrors={setSaveErrors}
          setShowSaveErrors={setShowSaveErrors}
          handleClose={handleClose}
        />
      </div>
    </>
  );
};
